import React, {Component, Fragment} from "react";
import "./forgot_password.css";
import {Col, Form, Input, InputGroup, Row} from "reactstrap";
import {withRouter} from "react-router-dom";
import ToastHelper from "../../../utils/ToastHelper";
import CookieService, {CookieKey} from "../../../services/CookieService";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import ForgotPasswordService from "../../../services/ForgotPasswordService";

class ForgotPassword extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userName: CookieService.getCookie(CookieKey.RETURNING_USER, "")
        };

        this.validateForm = this.validateForm.bind(this);
        this.forgotPassword = this.forgotPassword.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    validateForm() {
        return this.state.userName.length > 0;
    }

    forgotPassword(){
        ForgotPasswordService.forgotPassword(this.state.userName).then(response => {
            if (response) {
                ToastHelper.success("If this is a valid username, we have sent you a new PIN.")
                this.props.history.replace("");
            }
        })
    }

    render() {
        return <Fragment>
            <div className={"background"}>
                <div className={"center"}>
                    {this.renderLogo()}
                    <br />
                    <Form onSubmit={this.handleSubmit}>
                        {this.renderForm(this.props.isMobile ? "mobile" : "browser")}
                    </Form>
                </div>
            </div>
        </Fragment>
    }

    renderForm(className) {
        return <div className={className + " forgot_password_form"}>
            <p>
                Enter your username below to receive a new PIN.
            </p>
            <InputGroup className="mb-3">
                <Input className={"forgot_password_input"} id="userName"
                       placeholder="Username"
                       value={this.state.userName}
                       onChange={(event) => this.handleChange(event)}/>
            </InputGroup>
            {<div className={"forgot_password_button_div"}>
                <Row>
                    <Col md={12}>
                        {this.renderChangePasswordButton(className)}
                    </Col>
                    <Col md={12}>
                        {this.renderBackButton(className)}
                    </Col>
                </Row>
            </div>
            }
        </div>
    }


    renderLogo() {
        return <div className={"forgot_password_logo_div"}>
            <img className={"forgot_password_logo browser"} src={"./assets/RiaLogoVariations/ria_logo_horizontal_colour.png"} alt=""/>
        </div>
    }

    renderChangePasswordButton(className) {

        return <Fragment>
            <SFXButtonComponent className={className + "_forgot_password_button"} onClick={this.forgotPassword}
                                disabled={!this.validateForm()}
            >Send
            </SFXButtonComponent>
        </Fragment>
    }

    renderBackButton(className) {

        return <Fragment>
            <SFXButtonComponent className={className + " back"}
                                onClick={() => this.props.history.push("/home")}>
                Back
            </SFXButtonComponent>
        </Fragment>
    }
}

export default withRouter(ForgotPassword);